// extracted by mini-css-extract-plugin
module.exports = {"container":"SimpleForm_container__3wAq_","containerRow":"SimpleForm_containerRow__1l60e","buttonsContainer":"SimpleForm_buttonsContainer__bVM_K"};